/** Contexte d'accès renvoyé par l'API d'administration COM+. */
export interface ComPlusAdminAccess {
  /** `true` pour un vendeur administrateur, `false` pour le site client. */
  isVendor: boolean;
  /** Ouverture de l'écran au site client (réglage piloté depuis la version vendeur). */
  customerAccessEnabled: boolean;
  /** Fermeture automatique de l'accès client (ISO 8601), `null` si fermé. */
  customerAccessExpiresAt: string | null;
}

export interface ComPlusAdminQuoteLine {
  ean: string;
  description: string;
  note: string;
  quantity: number;
  unitPrice: number;
}

/** Devis COM+ saisi librement. */
export interface ComPlusAdminQuote {
  componentId: string;
  type: string;
  projectReferencePrefix: string;
  projectName: string;
  customerId: string;
  vendorId: string;
  storeId: string;
  /** `null` : le nœud Contact n'est pas envoyé. */
  contactedByPhone: boolean | null;
  lines: ComPlusAdminQuoteLine[];
}

export interface ComPlusAdminXml {
  filename: string;
  contentType: string;
  xmlBase64: string;
}

export interface ComPlusSendResult {
  /** Réponse brute de COM+. */
  response: string;
  /** Numéro d'opportunité extrait de la réponse, si présent. */
  opportunityNumber?: string;
}

/**
 * Identifiant client attendu par COM+, même règle que les configurateurs :
 * préfixé par `SQ_` pour l'émetteur HOMEBYME, sans préfixe sinon.
 */
export function formatComPlusCustomerId(customerId: string, componentId: string): string {
  const id = (customerId ?? '').trim();
  if (!id) {
    return id;
  }
  return (componentId ?? '').trim().toUpperCase() === 'HOMEBYME'
    ? id.startsWith('SQ_')
      ? id
      : `SQ_${id}`
    : id.replaceAll('SQ_', '');
}
